import { getStoredToken } from './authToken';

/**
 * Upload a file to Emergent object storage via the backend.
 * Returns the public URL to reference the stored file.
 */
export const uploadFile = async ({ file, folder, bucketKey, entityId = null }) => {
  const token = getStoredToken();
  if (!token) throw new Error('Not authenticated');

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (!backendUrl) throw new Error('REACT_APP_BACKEND_URL is not configured');

  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder || bucketKey || 'uploads');
  if (bucketKey) formData.append('bucket_key', bucketKey);
  if (entityId) formData.append('entity_id', entityId);

  const res = await fetch(`${backendUrl}/api/upload`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  const rawText = await res.text();
  let dataJson = null;
  try {
    dataJson = rawText ? JSON.parse(rawText) : null;
  } catch {
    dataJson = null;
  }

  if (!res.ok) {
    throw new Error(dataJson?.detail || dataJson?.message || 'File upload failed');
  }

  const publicUrl = dataJson?.publicUrl || dataJson?.url;
  if (!publicUrl) throw new Error('Upload response is invalid');
  return publicUrl;
};
